class NodeJsonFormatter {
    format(rootNode) {
        return {
            units: (rootNode?.children ?? []).map(unit => ({
                name: unit.value,
                pages: unit.children.map(page => ({id: page.value.id, name: page.value.name})),
            })),
        };
    }
}

export {NodeJsonFormatter};
